"use strict";
import Swiper from "swiper";
import {Autoplay, Grid, Navigation, Pagination, Thumbs} from "swiper/modules"
import SwiperAnimation from '@cycjimmy/swiper-animation';
import Cookies from 'js-cookie'
import {CountUp} from "countup.js";

var App = function () {
    let swiperAnimation;
    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Autoplay, Thumbs, Grid]);
        swiperAnimation = new SwiperAnimation();
    }
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined;
    }


    const otherSlide = () => {

        var swiper4 = new Swiper(".home-other-services", {
            slidesPerView: 1,
            spaceBetween: 15,
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                576: {
                    slidesPerView: 2
                },
                768: {
                    slidesPerView: 3
                },
                992: {
                    slidesPerView: 4,
                    spaceBetween: 30,
                },
            }

        });
    }

    const Count = () => {

        const runCountUp = () => {
            document.querySelectorAll(".count").forEach((el) => {
                const end = parseFloat(el.dataset.end);

                const counter = new CountUp(el, end, {
                    duration: 2,
                });

                if (!counter.error) {
                    counter.start();
                } else {
                    console.error(counter.error);
                }
            });
        };
        const isScrolledIntoView = (el) => {
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        };

        const firstCountEl = document.querySelector(".count");
        let scrollStarted = false;

        if (firstCountEl) {
            const onScroll = () => {
                if (!scrollStarted && isScrolledIntoView(firstCountEl)) {
                    runCountUp();
                    scrollStarted = true;
                    window.removeEventListener("scroll", onScroll);
                }
            };

            window.addEventListener("scroll", onScroll);
        }

        const target = document.querySelector(".has-count-up");

        if (target) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "class") {
                        if (target.classList.contains("active")) {
                            runCountUp();
                        }
                    }
                });
            });

            observer.observe(target, {attributes: true});
        }
    };


    const goTop = () => {
        const goTop = document.getElementById('goTop');
        const circle = goTop.querySelector('.progress-ring__circle');
        const radius = 18;
        const circumference = 2 * Math.PI * radius;

        circle.style.strokeDasharray = circumference;
        circle.style.strokeDashoffset = circumference;

        window.addEventListener('scroll', () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const progress = scrollTop / docHeight;

            circle.style.strokeDashoffset =
                circumference - progress * circumference;
        });

        goTop.addEventListener('click', () => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    }

    return {
        init: function () {
            swiperUse();
            otherSlide();
            Count();
            goTop();

        },
    };
}();

window.addEventListener("load", function () {
    App.init();
});



